'use strict';

module.exports = function shift() {
  return this.items.shift();
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/shift.js
// module id = 287
// module chunks = 0